import React from "react";

const Section = ({ id, label, value, onToggle, onText }) => (
  <div className="exam-row">
    <label>
      <input type="checkbox" checked={value.on === 1} onChange={(e)=>onToggle(id, e.target.checked ? 1 : 0)} />
      {" "}{label}
    </label>
    <textarea rows={2} value={value.text} onChange={(e)=>onText(id, e.target.value)} placeholder="Finding..." />
  </div>
);

export default function ExamForm({ exam, onChange }) {
  const toggle = (k, v) => onChange({ ...exam, [k]: { ...exam[k], on: v } });
  const setTxt = (k, v) => onChange({ ...exam, [k]: { ...exam[k], text: v } });

  return (
    <div className="cn-card">
      <h3>Physical Examination</h3>
      {Object.entries(exam).map(([id, val]) => (
        <Section key={id} id={id} label={id} value={val} onToggle={toggle} onText={setTxt} />
      ))}
    </div>
  );
}
